(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove', 'touchmove'];
